package com.tovtalk.data.remote.dto

import kotlinx.serialization.Serializable

/** Inner `data` of GET /api/v2/pages/{slug}?lang= (wrapped in V2Response). HTML content for WebView. */
@Serializable
data class PageContentDto(
    val content: String = "",
    val locale: String = "he"
)
